export const party =[
    {id:1,   name:"Big party", wood:29700, clay:33250, iron:32000, crop:6700},
    {id:2,   name:"Small party", wood:6400, clay:6650, iron:5940, crop:1340},
    {id:3,   name:"Brewery party", wood:3870, clay:1680, iron:2450, crop:10900},
    
]